import * as React from "react";
import Card from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
import { Box, Theme, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { mutateFinishRegistration, MutateFinishRegistrationParams } from "api/mutations/userFinishRegistration";
import {
    Loading, useNotify, useRedirect,
} from "react-admin";
import { useLocation } from "react-router-dom";

function useQueryParams() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const useStyles = makeStyles(
    (theme: Theme) => ({
        main: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage:
                'radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)',
        },
        card: {
            width: 300,
            marginTop: '6em',
            marginBottom: '6em',
        },
    }),
);

const UserVerify = (props: {}) => {
    const classes = useStyles(props);
    const { t } = useTranslation();
    const queryParams = useQueryParams();
    const request: MutateFinishRegistrationParams = {userId: parseInt(queryParams.get('userId') ?? '0'), token: queryParams.get('token') ?? 'a'};
    const { isError, isSuccess, } = useQuery('verify', () => mutateFinishRegistration(request), {retry: false, retryOnMount: false});
    const notify = useNotify();
    const redirect = useRedirect();

    if (isSuccess) {
        notify(t('signUpVerify.accountActivated'), {type: 'success'});
        redirect('/login');
    }

    if (isError) {
        return (
            <div className={classes.main}>
                <Card className={classes.card}>
                    <Box p={1} mt={2}>
                        <Typography variant="h5" align="center">
                            {t('signUpVerify.verifyYourEmail')}
                        </Typography>
                    </Box>
                    <Box p={1} mt={2} mb={2}>
                        <Typography align="center">
                            {t('signUpVerify.linkExpired')}
                        </Typography>
                    </Box>
                </Card>
            </div>
        );
    }

    return <Loading />;
}

export default UserVerify;